import React from 'react'
import ReactDOM from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import { BrowserRouter, Switch, Route, Link, Redirect } from 'react-router-dom'

import rootReducer from './reducers'

import './index.css'
import registerServiceWorker from './registerServiceWorker'

import { QSWrapper } from './wrappers'
import Home from './components/Home'
import Login from './containers/Login'
import Plan from './containers/Plan'
import Firmware from './components/FirmwareField'

const store = createStore(
  rootReducer
)

const QSLogin = QSWrapper(Login)

const PrivateRoute = ({ component: Component, path, ...rest }) => (
  <Route {...rest} path={path} render={(props) => (
    store.getState().user && store.getState().user.login
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        search: `redirect=${path}`,
      }} />
  )} />
)

store.subscribe(() => {
  console.log(store.getState())
})

const Header = () => (
  <div className="header">
    <Link to="/">Home</Link>
    {
      !store.getState().user.login &&
      <Link to="/login">Login</Link>
    }
    <Link to="/plan">Plan</Link>
    <Link to="/firmware">Firmware</Link>
  </div>
)

const Main = () => (
  <Switch>
    <Route exact path="/" component={Home}/>
    <Route path="/login" render={(props) => {
      const state = store.getState()
      return state.user && state.user.login
        ? <Redirect to="/"/> 
        : <QSLogin {...props} />
    }}/>
    <PrivateRoute path="/plan" component={Plan}/>
    <PrivateRoute path="/firmware" component={Firmware}/>
  </Switch>
)

const App = () => (
  <React.Fragment>
    <Header/>
    <Main/>
  </React.Fragment>
)

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js